/**
 * Mensajes y textos reutilizables de la aplicación
 */

export const MENSAJES = {
  WHATSAPP_ENVIAR_ERROR: `<strong>Requisitos:</strong><br>• Teléfono del cliente: 10 dígitos<br>• Al menos un enlace de video registrado`,
} as const;
